var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F22",
    d: "M17.333 2.75h-.917V.917h-1.833V2.75H5.416V.917H3.583V2.75h-.917A1.84 1.84 0 0 0 .833 4.583V19.25c0 1.008.825 1.833 1.833 1.833h14.667a1.84 1.84 0 0 0 1.833-1.833V4.583a1.84 1.84 0 0 0-1.833-1.833m0 16.5H2.666V7.333h14.667z"
  })));
};
export default SvgCalendar;